/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstyleeast3Inputs */



/**
* | output |
* | --- |
* | "Warm Bringer" |
*
* @param {Personalityhumorstyleeast3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstyleeast3 = /** @type {((inputs?: Personalityhumorstyleeast3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstyleeast3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Warm Bringer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generador de calidez")
	return /** @type {LocalizedString} */ ("Теплоносец")
});
export { personalityhumorstyleeast3 as "personalityHumorStyleEast" }